<template>
	<div class="Modal ModalNoticeOrganization" v-if="isShow">
		<div class="Popup__background"></div>
		<div class="Modal__container">
			<div class="Modal__content">
				<h5>{{ tt('조직도 설정하기') }}</h5>
				<p
					v-html="
						tt(
							'기관 내 <b>그룹(부서/연구실/팀)</b>을 트리구조로 등록할 수 있습니다.<br>그룹별로 <b>그룹원 관리,</b> 그룹에 <b>접근 가능한 인원/그룹을 관리</b>할 수 있습니다.'
						)
					"
				></p>
				<div class="imgbox">
					<img src="@/assets/images/create-1.png" />
				</div>
				<div class="btn-group">
					<button class="Btn__yellow" @click="close">
						{{ tt('시작하기') }}
					</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import MixinModal from '@/mixins/modal'

export default {
	name: 'ModalNoticeOrganization',
	mixins: [MixinModal],
	methods: {
		close() {
			this.$emit('hideNotice')
		},
	},
}
</script>

<style lang="scss" scoped>
.ModalNoticeOrganization {
	.Modal__container {
		.Modal__content {
			padding: 40px;
			max-height: unset;
			overflow: initial;
			h5 {
				font-size: 1.5rem;
				font-weight: 700;
				width: 100%;
				text-align: left;
			}
			p {
				font-size: 0.875rem;
				color: $DEFAULT;
				margin-top: 10px;
				width: 100%;
				text-align: left;
			}
			.imgbox {
				margin: 30px 0;
				width: 600px;
				img {
					width: 100%;
				}
			}
			.Btn__yellow {
				width: 195px;
				height: 48px;
				font-size: 1rem;
				font-weight: 700;
			}
		}
	}
}
</style>
